import {kInternalRoutes} from "./internalRoutes";
import {kHomeTexts, kSystemDrawerNavText} from "./texts";
import {kSystemIcons} from "./icons";

// Used through the app to list a set of navigation related
// constants

// ---- About screen sub navigation
export const kAboutNavigation = [
    {
        icon: 'track_changes',
        title: "Notre mission",
        smallTitle: "Mission",
    },
    {
        icon: 'psychology',
        title: "Notre méthode",
        smallTitle: "Méthode",
    },
    {
        icon: 'groups',
        title: "Notre équipe",
        smallTitle: "Équipe",
    },
    {
        icon: 'send',
        title: "Nous contacter",
        smallTitle: "Contact",
    },
]

// ---- brevetScreen
export const kBrevetNavigation = [
    {
        name: "Savoir-faire",
        icon: kSystemIcons.category
    },
    {
        name: "Sujets",
        icon: kSystemIcons.exam
    },
];

// ---- homeScreen
export const kHomeFooterAboutNavItems = [
    {
        text: "Notre mission",
        link: { pathname: kInternalRoutes.about, state: { tab: 0 } },
    },
    {
        text: "Notre méthode",
        link: { pathname: kInternalRoutes.about, state: { tab: 1 } },
    },
    {
        text: "Qui sommes-nous ?",
        link: { pathname: kInternalRoutes.about, state: { tab: 2 } },
    },
]

export const kHomeFooterActivityNavItems = [
    {
        text: "Cours et exercices",
        link: { pathname: kInternalRoutes.courses},
    },
    {
        text: "Brevet",
        link: { pathname: kInternalRoutes.brevet},
    },
    {
        text: "Glossaire",
        link: { pathname: kInternalRoutes.glossary},
    },
    {
        text: "Jeux",
        link: { pathname: kInternalRoutes.games},
    }
]

export const kHomeFooterLegalNavItems = [
    {
        text: "Politique de confidentialité",
        link: { pathname: kInternalRoutes.privacy},
    },
    {
        text: "Mentions légales",
        link: { pathname: kInternalRoutes.legals},
    }
]

// ---- SYSTEM
export const kSystemMainNavigationItems = [
    {
        name: kHomeTexts.navCourses,
        route: kInternalRoutes.courses,
    },
    {
        name: kSystemDrawerNavText.brevet,
        route: kInternalRoutes.brevet,
    },
    {
        name: kHomeTexts.navGames,
        route: kInternalRoutes.games,
    },
]

export const kSystemDrawerMainNavigationItems = [
    {
        name: kSystemDrawerNavText.courses,
        icon: kSystemIcons.book,
        route: kInternalRoutes.courses,
        tooltip: "Cours et exercices"
    },
    {
        name: kSystemDrawerNavText.brevet,
        icon: kSystemIcons.school,
        route: kInternalRoutes.brevet,
        tooltip: "Brevet"
    },
    {
        name: kSystemDrawerNavText.glossary,
        icon: kSystemIcons.dictionary,
        route: kInternalRoutes.glossary,
        tooltip: "Glossaire"
    },
    {
        name: kSystemDrawerNavText.games,
        icon: kSystemIcons.games,
        route: kInternalRoutes.games,
        tooltip: "Jeux"
    },
]

export const kSystemDrawerAboutNavigationItems = [
    {
        name: kSystemDrawerNavText.themes,
        icon: kSystemIcons.balance,
        route: kInternalRoutes.themes,
    },
    {
        name: kSystemDrawerNavText.about,
        icon: kSystemIcons.about,
        route: kInternalRoutes.about,
    },
]

export const kSystemDrawerLegalsNavigationItems = [
    {
        name: kHomeTexts.navLegals,
        icon: kSystemIcons.assignment,
        route: kInternalRoutes.legals,
    },
    {
        name: kHomeTexts.navPrivacy,
        icon: kSystemIcons.lock,
        route: kInternalRoutes.privacy,
    }
]